var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',{staticClass:"mb-2"},[_c('v-col',[_c('h3',[_vm._v("Campaigns")])])],1),_c('ProgrammaticAppsTable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }